module.exports = __webpack_public_path__ + "img/headBg.368fec7c.png";